var map = {
	"./comodo-secure.png": 1203,
	"./flag-france.png": 1204,
	"./flag-germany.png": 1205,
	"./flag-italy.png": 1206,
	"./flag-netherlands.png": 1207,
	"./flag-portugal.png": 1208,
	"./flag-spain.png": 1209,
	"./flag-usa.png": 1210,
	"./global-cart-seal.png": 1211,
	"./icon-wanelo copy.png": 1212,
	"./icon-wanelo.png": 1213,
	"./icon-whatsapp copy.png": 1214,
	"./icon-whatsapp.png": 1215,
	"./lock.png": 1216,
	"./pagamento-cinza.png": 1217,
	"./pagamento-verde.png": 1218,
	"./pagamento-vermelho.png": 1219,
	"./payment-methods-br.png": 1220,
	"./payment-methods-global.png": 1221,
	"./payment-methods.png": 1222,
	"./pedido-cinza.png": 1223,
	"./pedido-verde.png": 1224,
	"./pedido-vermelho.png": 1225,
	"./selo-ebit-ouro.png": 1226,
	"./selo-eureciclo.png": 1227,
	"./selo-internet-segura.png": 1228,
	"./selo-ra1000.png": 1229,
	"./selo_100-seguro-retina.png": 297,
	"./selo_100-seguro.png": 1230,
	"./selo_site_seguro_certisign.png": 1231,
	"./selo_site_seguro_mcafee.png": 1232,
	"./selo_site_seguro_norton.png": 1233,
	"./selo_site_seguro_norton_small.png": 1234,
	"./separacao-cinza.png": 1235,
	"./separacao-verde.png": 1236,
	"./separacao-vermelho.png": 1237,
	"./shipping-methods-global.png": 1238,
	"./transporte-cinza.png": 1239,
	"./transporte-verde.png": 1240,
	"./transporte-vermelho.png": 1241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1202;